// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { FieldsUpdate, State } from './FieldsUpdate.types.tsx';

export const captureLastFieldsUpdate =
	(lastFieldsUpdate: FieldsUpdate): Action<State> =>
	async ({ setState }) => {
		setState({
			lastFieldsUpdate,
		});
	};
